import React, { useState } from 'react'

import { Container } from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { ContentHeader, LoadingFeedback, Page } from 'components'

import { CommitteesForm, DialogNewCommitteeRole } from './components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'
import useStyles from './styles'

const CommitteeUsersEdit = () => {
  const [openDialogNewCommitteeRole, setOpenDialogNewCommitteeRole] =
    useState(false)
  const [loading, setLoading] = useState(false)
  const params = useParams()

  const classes = useStyles()

  const {
    response: committeeUserResponse,
    isLoading: isCommitteeUserLoading,
    refresh: refreshCommitteeUser,
  } = useFetch(service.dponet.committeeUsers.get, {
    committeeId: params.committeeId,
    committeeUserId: params.committeeUserId,
  })

  const committeeUser = committeeUserResponse?.data?.committeeUser

  const {
    response: committeeRolesResponse,
    isLoading: isCommitteeRolesLoading,
    refresh: refreshCommitteeRoles,
  } = useFetch(service.dponet.committeeRoles.get, {})

  const committeeRoles = committeeRolesResponse?.data?.committeeRoles

  return (
    <Page title="Editar membro de comitê">
      <LoadingFeedback
        open={loading || isCommitteeRolesLoading || isCommitteeUserLoading}
      />
      <Container maxWidth={false} className={classes.container}>
        <ContentHeader title="Editar membro"></ContentHeader>
        <CommitteesForm
          setLoading={setLoading}
          formType="edit"
          roles={committeeRoles}
          existingCommitteeUser={committeeUser}
          setOpenDialogNewCommitteeRole={setOpenDialogNewCommitteeRole}
          refresh={refreshCommitteeUser}
        />
      </Container>
      <DialogNewCommitteeRole
        open={openDialogNewCommitteeRole}
        setOpen={setOpenDialogNewCommitteeRole}
        onEvent={refreshCommitteeRoles}
      />
    </Page>
  )
}

export default CommitteeUsersEdit
